<template>
    <div class="page-content g9">
        <Accord title="Demand">

            <Accord title="Consumption">
                <LineChart chart-name="aggregationDemandConsumption" :settings="consumptionSettings" :isAggregation="true"></LineChart>
            </Accord>           
        </Accord>
    </div>
</template>

<script>
    import Accord from "../../Accord.vue"
    import LineChart from "../Charts/LineChart.vue"
    import DownloadLog from "../DownloadLog.vue"

    export default {
        components: {
            Accord,
            LineChart,
            DownloadLog
        },
        methods: {
            consumptionSettings(data) {
                let chart = this.cloneObject(this.$store.state.dataView.chartDefaults);

                chart.chart = {
                    zoomType: "x"
                };
                chart.tooltip = {
                    shared: true,
                    useHTML: true,
                    headerFormat: '<small>{point.key}</small><table><tr><td style="padding: 2px;">DUN</td><td style="padding: 2px;">Total accumulated</td><td style="padding: 2px;">Consumption</td></tr>',
                    pointFormat: '<tr><td style="color: {series.color};padding: 2px;">{series.name} </td>' +
                        '<td style="text-align: right;padding: 2px;"><b>{point.total:,.f}&nbsp;</b></td>'+
                        '<td style="text-align: right;padding: 2px;"><b>{point.quantity:,.f}</b></td></tr>',
                    footerFormat: '</table>',
                    valueDecimals: 2
                };

                for(let i = 0; i < data.series.length; i++)
                {
                    data.series[i].data = data.series[i].data.map(function(row){
                        return {
                            x: row.x,
                            y: row.y,
                            quantity: row.quantity,
                            total: row.total
                        }});
                }

                chart.series = data.series;
                chart.xAxis.type = "datetime";
                chart.yAxis.title.text = "DUN";
                chart.xAxis.title.text = "Date";

                return chart;
            }
            ,
            isSuperAdmin() {
                return this.$store.state.member.isSuperAdmin;
            }
        }
    }
</script>
